/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SuccessIcon = /*#__PURE__*/ createSvgIcon(
  'SuccessIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.938 10.875l-1.25-1.23a.718.718 0 00-.521-.228.718.718 0 00-.521.229.73.73 0 000 1.062l1.77 1.771c.153.153.327.23.521.23a.718.718 0 00.521-.23l3.896-3.896a.73.73 0 000-1.062.718.718 0 00-.52-.23.718.718 0 00-.521.23l-3.376 3.354zM10 18a7.796 7.796 0 01-3.104-.625 8.064 8.064 0 01-2.552-1.719 8.063 8.063 0 01-1.719-2.552A7.797 7.797 0 012 10c0-1.111.208-2.15.625-3.115a8.064 8.064 0 014.27-4.26A7.797 7.797 0 0110 2c1.111 0 2.15.208 3.115.625a8.095 8.095 0 014.26 4.26C17.792 7.851 18 8.89 18 10a7.797 7.797 0 01-.625 3.104 8.063 8.063 0 01-4.26 4.271A7.774 7.774 0 0110 18z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SuccessIcon;
